<div *ngIf="toggled && isMobile" class="jmCollapseTitleLearnMore">
	<div class="jmPageTitle" style="padding-top: 10px;">
		Skills Matcher <span *ngIf="assessmentCompleted">Results</span>
		<div class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square" role="button" (click)="toggleCollapse()"></div>
	</div>
</div>

<div *ngIf="!toggled && retrievingData" class="d-flex align-items-center justify-content-center w-100 h-100">
	<span class="jmWidgetLoadingIcon40"></span>
</div>

<div *ngIf="!retrievingData && !toggled && !assessmentCompleted" class="h-100 jmWidgetPadding bg-white">

	<div *ngIf="isMobile" class="jmPageTitle">
		Skills Matcher
		<div role="button" (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square"></div>
	</div>

	<div style="display: flex; flex-direction: column;" class="w-100 text-center" [ngStyle]="isMobile? {'height':'325px' }:{'height':'100%'}">
		<div *ngIf="!isMobile" class="jmPageTitle text-start">Skills Matcher</div>
		<div style="display: flex; align-items: center; flex-direction: column; padding: 10px 0 10px 0;">
			<!--[ngStyle]="isMobile? {'width':'auto','height':'auto'}:{'width':'auto','height':'auto'}"-->
			<img src="assets/images/splash_skill_assess.png" class="circleImageScale" />
		</div>
		<div style="margin-bottom: auto; overflow-y: auto;">Interested in seeing how your skills match with potential careers? Take our 10 minute Skills Matcher to get connected with careers that best fit you!</div>
		<div style="display: flex; flex-direction: column;">			
			<button style="align-self: flex-start; margin-left: auto; margin-right: auto;" class="btn btn-primary" (click)="takeAssessment($event)">Take Assessment</button>
			<img src="assets/images/career-onestop.jpg" style="height: 15px; width: auto; align-self: flex-start; margin-left: auto; margin-right: auto; margin-top: 5px;" />
		</div>
	</div>
</div>

<!--skill test taken, widget shows this-->
<div *ngIf="!retrievingData && !toggled && assessmentCompleted" class="h-100 jmWidgetPadding bg-white">
	<div *ngIf="skillResult!=null" class="h-100" style="display: flex; flex-direction: column;">
		<div class="jmPageTitle bigScreenHeader" style="margin-bottom: 10px;">
			Skills Matcher Results
			<div *ngIf="isMobile" (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square" style="margin-top:10px;"></div>
		</div>
		<div class="jmPageTitle smallScreenHeader" style="margin-bottom: 10px;">
			Skills Matcher Results
			<div *ngIf="isMobile" (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square" style="margin-top:10px;"></div>
		</div>

		<div style="display: flex; justify-content: center; align-items: center; margin-bottom: 10px;">
			<i class="fas fa-trophy" style="font-size: 25px; color: var(--bs-secondary); display: inline;"></i>
			<div style="margin-left: 10px;"><b>BEST FIT</b></div>
		</div>

		<div *ngFor="let answer of (skillResult.Answers? skillResult.Answers.slice(0,3):[]); let i=index;" style="display: flex; flex-direction: column; flex: 1; min-height: 0; margin-bottom: 10px;" [ngClass]="(i > 0)?'skillProfilerResultsSpacing':''">
			<div style="display: flex; align-content: center; justify-content: space-between">
				<div style="line-height: 28px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"><b>{{answer.ElementName}}</b></div>
				<div class="text-primary skillProfilerResultHide" style="line-height: 28px; white-space: nowrap;" role="button" (click)="readMore(answer)">
					Read More
				</div>
			</div>
			<div class="skillProfilerResultFullText">
				<div class="skillProfilerResultTruncateText">
					{{answer.EasyReadDescription}}
				</div>
			</div>
		</div>

		<div style="display: flex; align-items: center; justify-content: space-around; background-color: #f0f0f0; padding: 10px 0 5px 0; margin-top: 10px;">
			<div role="button" (click)="goResults($event)" style="display: flex; flex-direction: column; align-items: center;">
				<i class="text-primary icnChartBar" style="font-size: 25px; border-radius: 3px; padding: 0 6px 0 6px; line-height: 1.5;"></i>
				<div style="color: #95A5A6;">Results</div>
			</div>
			<div role="button" (click)="takeAssessment($event)" style="display: flex; flex-direction: column; align-items: center;">
				<i class="text-primary icnListCheck" style="font-size: 25px; line-height: 1.5;"></i>
				<div style="color: #95A5A6;">Retake</div>
			</div>
		</div>
	</div>
</div>
